export const environment = {
    target: 'production',
    production: 'true',
    googleApiKey: 'AIzaSyAbsqZaOEWqHuw6NE3drfKEgZEceIJQrVo',
    analytics: 'UA-27202786-40',

    servers: {
        client: {
            root: '/espace-client',
            redirect: 'https://*.albr.io/espace-client/index.html'
        },
        authorization: {
            url: 'https://albr.io/authorization',
            client: 'espace-client',
            scope: 'R_USER',
            debug: false
        },
        resources: {
            url: 'https://albr.io/api',
            websocketWs: 'wss://albr.io/socket/ws/',
            websocketHttp: 'https://albr.io/socket/ws'
        }
    },

    version: '1.0.0-production',
    enableFunnelEscapeKey: true
};
